export const INVESTORS_URL = `${BACKOFFICE_API_URL}/investor`
export const PARTNERS_URL = `${BACKOFFICE_API_URL}/partners/partner`
export const ACCOUNTS_URL = `${BACKOFFICE_API_URL}/accounting/trading-accounts`
export const ACCOUNT_URL = `${ACCOUNTS_URL}/:id`
export const BALANCES_URL = `${BACKOFFICE_API_URL}/accounting/trading-accounts/:account_id/balance`
export const GET_BALANCES_ETP = `${BACKOFFICE_API_URL}/accounting/trading-accounts/:account_id/balance`
export const SUPPORTED_COUNTRIES_URL = `${BACKOFFICE_API_URL}/investor/countries`

export const STRATEGIES_URL = `${BACKOFFICE_API_URL}/investor/strategies`
export const STRATEGY_DETAILS_URL = `${STRATEGIES_URL}/:id`

export const STRATEGY_EDIT_URL = `${BACKOFFICE_API_URL}/investor/strategies/:id`

export const FIND_INVESTORS = `${BACKOFFICE_API_URL}/investor`
export const ACCOUNTS_ETP = `${BACKOFFICE_API_URL}/accounting/trading-accounts`
